import React, { useCallback } from 'react'
import { RecordHighlight, HighlightsBase, useHighlightData, MemoryHighlight } from '@fs/zion-image-viewer'
import { Card, Row, Button } from '@fs/zion-ui'
import { MenuClose, ContentCheck } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'

import { useSlsHighlightsContext } from '@fs/zion-sls'
import { useR2Highlights } from '../../providers/r2Provider/R2Context'
import useSlsHighlightEventListeners from '../../hooks/useSlsHighlightEventListeners'

const SelectedContent = ({ id, freezeAttachStateList, onToggleAttachedListener }) => {
  const { attached } = useHighlightData()
  const [t] = useTranslation()
  if (freezeAttachStateList?.includes(id)) {
    return null
  }
  return (
    <Card>
      <Row wrap alignX="center">
        <Button
          emphasis="medium"
          Icon={attached ? MenuClose : ContentCheck}
          onClick={() => onToggleAttachedListener(id)}
        >
          {attached ? t('highlights-base.button.detach', 'Detach') : t('highlights-base.button.attach', 'Attach')}
        </Button>
      </Row>
    </Card>
  )
}

export default function SlsHighlightsBase({
  forSplitScreen,
  showEditHighlights,
  freezeAttachStateList,
  state,
  dispatch,
}) {
  const {
    displayHighlights,
    splitScreenDisplayHighlights,
    recordDisplayHighlights,
    recordDisplayHighlightsApi,
    splitScreenRecordDisplayHighlights,
    splitScreenRecordDisplayHighlightsApi,
  } = useR2Highlights()
  const { isCreatingRects } = useSlsHighlightsContext()
  const { onHoverHighlight, onFocusHighlight, onUpdateHighlight, onToggleAttachedListener, onHoverRecordHighlight } =
    useSlsHighlightEventListeners({ forSplitScreen, state, dispatch })

  const SelectedContentProviderComponent = useCallback(
    ({ id }) => <SelectedContent {...{ id, freezeAttachStateList, onToggleAttachedListener }} />,
    [freezeAttachStateList, onToggleAttachedListener]
  )

  if (showEditHighlights) {
    return (
      <>
        <HighlightsBase
          editable
          drawMode={isCreatingRects}
          state={forSplitScreen ? splitScreenRecordDisplayHighlights : recordDisplayHighlights}
          api={forSplitScreen ? splitScreenRecordDisplayHighlightsApi : recordDisplayHighlightsApi}
          Component={MemoryHighlight}
          onHover={onHoverRecordHighlight}
        />
        <HighlightsBase
          editable
          // You CANNOT use an anonymous function here, it will cause the component to re-render every time, and throw away it's clickListener funcitons at JUST the wrong time
          SelectedContent={SelectedContentProviderComponent}
          drawMode={isCreatingRects}
          state={forSplitScreen ? splitScreenDisplayHighlights : displayHighlights}
          Component={RecordHighlight}
          onHover={onHoverHighlight}
          onFocus={onFocusHighlight}
          onUpdate={onUpdateHighlight}
        />
      </>
    )
  }
  return (
    <>
      <HighlightsBase
        state={forSplitScreen ? splitScreenRecordDisplayHighlights : recordDisplayHighlights}
        api={forSplitScreen ? splitScreenRecordDisplayHighlightsApi : recordDisplayHighlightsApi}
        Component={MemoryHighlight}
        onHover={onHoverRecordHighlight}
      />
      <HighlightsBase
        state={forSplitScreen ? splitScreenDisplayHighlights : displayHighlights}
        Component={RecordHighlight}
        onHover={onHoverHighlight}
        onFocus={onFocusHighlight}
      />
    </>
  )
}
